import { render, staticRenderFns } from "./ReturnItem.vue?vue&type=template&id=250b9f38&"
import script from "./ReturnItem.vue?vue&type=script&lang=js&"
export * from "./ReturnItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports